import {Vente} from '@/models';

export default [
	{
		path: '/ventes',
		name: 'ventes',
		meta: {
			title: 'Liste des ventes',
			granted: [ 'API_GET_VENTE' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Vente.vue')
	},
	{
		path: '/ventes/show/:id',
		name: 'vente-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Vente/Show.vue'),
				class: Vente
			}),
			editRoute: { name: 'vente-edit' },
		},
		meta: {
			title: 'Détail d\'une vente',
			granted: [ 'API_GET_VENTE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/ventes/edit/:id',
		name: 'vente-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Vente/Edit.vue'),
				class: Vente
			}),
		},
		meta: {
			title: 'Edition d\'un vente',
			granted: [ 'API_PUT_VENTE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
